
import React, {  useEffect, useState } from "react";

// reactstrap components
import {
  Button,Table,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";




function FeaturesList(props) {

  let data = props.features.valueRange.map((aa,key) =>{
    
   return {
      key  : key,
      vrid : aa.vrid,
      id: key,
      len : aa.len,
     
  }})
  return (
    <>
  
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
            
              <CardBody>
                  <Table>
                      <thead>
                        <tr>
                        
                          <th>Value</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {props.features.valueRange.map((t, key) => {
                          return (
                            <tr  key={key} >
                           
                              <th>{t.len}</th>
                              <th><i className="fa fa-remove" aria-hidden="true" 
                                onClick={() => {
                                  if(props.sbut){
                                   return  
                                  }else{
                                    let obj = data.filter((o) => o.vrid !== t.vrid);
                                    
                                      props.setFeatures({...props.features, valueRange : obj})
                                  }
                                  }}
                              ></i></th>
                            </tr>
                          )
                        })}
                      </tbody>
                  </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default FeaturesList;